var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSales(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5781_91525",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5781_91525)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33341 17.4993C2.87508 17.4993 2.48286 17.3363 2.15675 17.0102C1.83008 16.6835 1.66675 16.291 1.66675 15.8327V6.66602C1.66675 6.20768 1.83008 5.81546 2.15675 5.48935C2.48286 5.16268 2.87508 4.99935 3.33341 4.99935H6.66675V3.33268C6.66675 2.87435 6.83008 2.48185 7.15675 2.15518C7.48286 1.82907 7.87508 1.66602 8.33341 1.66602H11.6667C12.1251 1.66602 12.5176 1.82907 12.8442 2.15518C13.1704 2.48185 13.3334 2.87435 13.3334 3.33268V4.99935H16.6667C17.1251 4.99935 17.5176 5.16268 17.8442 5.48935C18.1704 5.81546 18.3334 6.20768 18.3334 6.66602V15.8327C18.3334 16.291 18.1704 16.6835 17.8442 17.0102C17.5176 17.3363 17.1251 17.4993 16.6667 17.4993H3.33341ZM8.33341 4.99935H11.6667V3.33268H8.33341V4.99935ZM16.6667 12.4993H12.5001V14.166H7.50008V12.4993H3.33341V15.8327H16.6667V12.4993ZM9.16675 12.4993H10.8334V10.8327H9.16675V12.4993ZM3.33341 10.8327H7.50008V9.16601H12.5001V10.8327H16.6667V6.66602H3.33341V10.8327Z",
    fill: "#8D8885"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSales);
export default __webpack_public_path__ + "static/media/sales.df48bbb032799c5597c85ac45a8b9fc8.svg";
export { ForwardRef as ReactComponent };